import { createContext, useState } from "react";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";

import {
  changePasswordService,
  confirmChangePasswordService,
  changePinService,
} from "../../../services/userServices";

export const changePasswordCustomerContext = createContext({
  phonenumber: "",
  setPhonenumber: () => {},
  isCodeSent: null,
  setIsCodeSent: () => {},
  isOpenModal: null,
  setIsOpenModal: () => {},
  handleChangePassword: () => {},
  handleConfirmChangePassword: () => {},
  isShowCurrentPass: null,
  setIsShowCurrentPass: () => {},
  isShowNewPass: null,
  setIsShowNewPass: () => {},
  isShowConfirmPass: null,
  setIsShowConfirmPass: () => {},
  handleChangePin: () => {},
  changePin: "",
  setChangePin: () => {},
  confirmChangePin: "",
  setConfirmChangePin: () => {},
  pinPhoneNumber: "",
  setPinPhoneNumber: () => {},
  pinPassword: "",
  setPinPassword: () => {},
  view: "",
  setView: () => {},
});

const ChangePasswordCustomerContext = ({ children }) => {
  const dispatch = useDispatch();

  const [phonenumber, setPhonenumber] = useState("");
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isCodeSent, setIsCodeSent] = useState(false);

  const [isShowCurrentPass, setIsShowCurrentPass] = useState(false);
  const [isShowNewPass, setIsShowNewPass] = useState(false);
  const [isShowConfirmPass, setIsShowConfirmPass] = useState(false);

  const [changePin, setChangePin] = useState("");
  const [confirmChangePin, setConfirmChangePin] = useState("");
  const [pinPhoneNumber, setPinPhoneNumber] = useState("");
  const [pinPassword, setPinPassword] = useState("");

  const [view, setView] = useState("password");

  // Handle Change Password
  const handleChangePassword = async (userData, event) => {
    event?.preventDefault();

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await changePasswordService(userData);
      if (status === 200) {
        setPhonenumber(userData.phonenumber);
        setIsCodeSent(true);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Confirm Change Password
  const handleConfirmChangePassword = async (userData, event) => {
    event?.preventDefault();

    const objData = {
      ...userData,
      phonenumber,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await confirmChangePasswordService(objData);
      if (status === 200) {
        setPhonenumber("");
        setIsCodeSent(false);
        setIsOpenModal(false);
        toast.success("رمز عبور شما با موفقیت تغییر پیدا کرد");
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Change Pin
  const handleChangePin = async (event) => {
    event?.preventDefault();

    const objData = {
      phonenumber: pinPhoneNumber,
      pin: changePin,
      confirmpin: confirmChangePin,
      password: pinPassword,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await changePinService(objData);
      if (status === 200) {
        // setIsOpenChangePinModal(false);
        setChangePin("");
        setConfirmChangePin("");
        toast.success("پین شما با موفقیت تغییر پیدا کرد");
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <changePasswordCustomerContext.Provider
      value={{
        phonenumber,
        setPhonenumber,
        isCodeSent,
        setIsCodeSent,
        isOpenModal,
        setIsOpenModal,
        handleChangePassword,
        handleConfirmChangePassword,
        isShowCurrentPass,
        setIsShowCurrentPass,
        isShowNewPass,
        setIsShowNewPass,
        isShowConfirmPass,
        setIsShowConfirmPass,
        handleChangePin,
        changePin,
        setChangePin,
        confirmChangePin,
        setConfirmChangePin,
        pinPhoneNumber,
        setPinPhoneNumber,
        pinPassword,
        setPinPassword,
        view,
        setView,
      }}
    >
      {children}
    </changePasswordCustomerContext.Provider>
  );
};

export default ChangePasswordCustomerContext;
